import { combineEpics } from 'redux-observable';

import { loadRequests } from './loadRequests';
import { reload } from './reload';

export default combineEpics(loadRequests, reload);



// WEBPACK FOOTER //
// ./src/scenes/Requests/services/epics/index.ts